import React, { useState, useEffect } from "react";
import fgLogo from "../../img/fg-logo-p.png";
import Header from "../Header/Header";
import { useParams } from "react-router";
import { services } from "../../api";
import { Loader } from "../Utils/Loader";
import { useSelector } from "react-redux";

export const UnSubscribe = () => {
  const params = useParams();
  const { loader } = useSelector((state) => state.HeaderReducer);
  const { unSubscribeType, unSubscribeValue } = params;
  const [ message, setMessage ] = useState("");

  useEffect(async () => {
    let res = await services.unSubscribe(
      `unsubscribe?type=${unSubscribeType}`,
      "put",
      {
        value: unSubscribeValue,
      }
    );
    setMessage(res.message);
  }, []);

  if (loader) {
    return <Loader />;
  }
  return (
    <div className="unsubscribe-container">
      <Header isHeader={true} />
      <div id="login-page" className="row custom-log-row">
        <div className="col s12 custom-z-depth-4 card-panel">
          <form className="unsubscribe-form">
            <div className="row p-t-30">
              <div className="input-field">
                <img src={fgLogo} alt="" className="responsive-img logo-image" />
              </div>
            </div>
            <p className="logo-paragraph">Fault Reporter</p>
            <div className="row">
              <p className="subscrib-row">{message}</p>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
